<template>
  <div
    class="d-flex flex-column flex-root"
    :class="{ 'sa-theme': isSuperAdmin, 'biz-theme': isBusinessUser }"
    style="width: 100%; max-width: 100%;"
  >
    <!-- begin:: Header Mobile -->
    <KTHeaderMobile></KTHeaderMobile>
    <!-- end:: Header Mobile -->

    <!-- Full-screen Metronic loader removed — API loading uses top progress bar via body.page-loading -->

    <!-- begin::Body -->
    <div class="d-flex flex-row flex-column-fluid page" style="width: 100%; max-width: 100%;">
      <!-- begin:: Aside Left -->
      <KTAside v-if="asideEnabled"></KTAside>
      <!-- end:: Aside Left -->

      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper" style="width: 100%; max-width: 100%;">
        <!-- begin:: Header -->
        <KTHeader></KTHeader>
        <!-- end:: Header -->

        <!-- begin:: Content -->
        <div
          id="kt_content"
          class="content d-flex flex-column flex-column-fluid"
          style="width: 100%; max-width: 100%;"
        >
          <!-- begin:: Content Head -->

          <!-- begin:: Content Head -->
          <KTSubheader
            v-if="subheaderDisplay"
            v-bind:breadcrumbs="breadcrumbs"
            v-bind:title="pageTitle"
          />
          <!-- end:: Content Head -->

          <!-- begin:: Content Body -->
          <div class="d-flex flex-column-fluid" style="width: 100%; max-width: 100%;">
            <div
              class="layout-page-bottom-pad"
              :class="{
                'container-fluid': contentFluid,
                container: !contentFluid
              }"
            >
              <transition name="fade-in-up">
                <router-view />
              </transition>
            </div>
          </div>
        </div>
        <Footer v-if="!isSuperAdmin"></Footer>
      </div>
    </div>
    <KTStickyToolbar v-if="toolbarDisplay && !isSuperAdmin"></KTStickyToolbar>
    <KTScrollTop></KTScrollTop>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeader from "@/view/layout/header/Header.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import Footer from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";

export default {
  name: "Layout",
  components: {
    KTAside,
    KTHeader,
    KTHeaderMobile,
    Footer,
    KTSubheader,
    KTStickyToolbar,
    KTScrollTop
  },
  beforeMount() {
    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    document.title = "GetMeFood";
    document.body.style.background = "";
    if (this.isSuperAdmin || this.isBusinessUser) {
      document.body.classList.remove("subheader-enabled", "subheader-fixed");
    }
  },
  beforeDestroy() {
    document.body.style.background = "";
  },
  watch: {
    isSuperAdmin(val) {
      if (val) {
        document.body.classList.remove("subheader-enabled", "subheader-fixed");
      }
    },
    isBusinessUser(val) {
      if (val) {
        document.body.classList.remove("subheader-enabled", "subheader-fixed");
      }
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser"
    ]),

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return true;
      //return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      return !!this.layoutConfig("toolbar.display");
      // return true;
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      if (this.isSuperAdmin) return false;
      // Hide breadcrumb bar for business — was creating a large gap above dashboard cards
      if (this.isBusinessUser) return false;
      return !!this.layoutConfig("subheader.display");
    },

    isSuperAdmin() {
      return this.$store.state.auth.isAuthenticated && !this.$store.state.auth.normal;
    },

    isBusinessUser() {
      return this.$store.state.auth.isAuthenticated && !!this.$store.state.auth.normal;
    }
  }
};
</script>
<style>
  body{
    font-size: 16px !important;
  }

  /* Fixed footer (#kt_footer) overlays the scroll area; keep page actions visible */
  .layout-page-bottom-pad {
    padding-bottom: 5.5rem;
    padding-bottom: calc(5.5rem + env(safe-area-inset-bottom, 0px));
    box-sizing: border-box;
  }

  .sa-theme .layout-page-bottom-pad {
    padding-bottom: 1.5rem;
  }

  /* —— Super Admin UI preview theme —— */
  .sa-theme #kt_content,
  .sa-theme .content {
    background: #faf8f6 !important;
    background-image: none !important;
    padding-top: 0 !important;
    padding-bottom: 12px !important;
    color: #475569 !important;
    font-family: "Inter", ui-sans-serif, system-ui, sans-serif;
  }

  .sa-theme .wrapper {
    background: #faf8f6 !important;
  }

  /* Subheader is hidden for SA but body classes still reserved its height */
  .sa-theme #kt_wrapper.wrapper {
    padding-top: 65px !important; /* header height only */
    background: #faf8f6 !important;
    background-image: none !important;
  }

  /* Desktop: only one top bar (desktop header). Hide mobile header completely. */
  @media (min-width: 992px) {
    .sa-theme #kt_header_mobile,
    .sa-theme .header-mobile,
    .sa-theme .sa-header-mobile,
    .biz-theme #kt_header_mobile,
    .biz-theme .header-mobile,
    .biz-theme .biz-header-mobile {
      display: none !important;
      height: 0 !important;
      min-height: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      border: none !important;
      overflow: hidden !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }

    .sa-theme #kt_header.header,
    .sa-theme .header.sa-header,
    .biz-theme #kt_header.header,
    .biz-theme .header.biz-header {
      display: flex !important;
      visibility: visible !important;
      pointer-events: auto !important;
      height: 65px !important;
      min-height: 65px !important;
      opacity: 1 !important;
    }
  }

  .sa-theme .container-fluid.layout-page-bottom-pad,
  .sa-theme .layout-page-bottom-pad {
    padding-top: 4px !important;
    margin-top: 0 !important;
  }

  .sa-theme .subheader {
    display: none !important;
    height: 0 !important;
    min-height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .sa-theme .sa-aside-footer {
    display: none !important;
  }

  .sa-theme #kt_header.header,
  .sa-theme .header.sa-header {
    background: #ffffff !important;
    box-shadow: 0 1px 0 rgba(15, 23, 42, 0.06) !important;
    border-bottom: 1px solid #eef1f6 !important;
    overflow: visible !important;
    /* Metronic uses left:aside + width:100%, which pushes the right edge off-screen */
    width: auto !important;
    max-width: none !important;
    right: 0 !important;
    display: flex !important;
    align-items: center !important;
  }

  .sa-theme #kt_header .container-fluid,
  .sa-theme #kt_header .sa-header-inner {
    padding-left: 0 !important;
    padding-right: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    flex: 1 1 auto !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    min-width: 0 !important;
  }

  .sa-theme .sa-header-right {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    visibility: visible !important;
    opacity: 1 !important;
    flex: 0 0 auto !important;
    margin-left: auto !important;
    margin-right: 16px !important;
    position: relative !important;
    z-index: 30 !important;
  }

  .sa-theme .sa-header-search {
    flex: 1 1 auto !important;
    min-width: 0 !important;
  }

  .sa-theme .topbar {
    position: static !important;
    height: auto !important;
    background: transparent !important;
    box-shadow: none !important;
    margin-top: 0 !important;
  }

  .sa-theme .topbar .mdi,
  .sa-theme .topbar .fa,
  .sa-theme .quick-user-toggle i {
    color: #475569 !important;
  }

  .sa-theme .header-mobile {
    background: #ffffff !important;
  }

  .sa-theme .header-mobile .burger-icon span,
  .sa-theme .header-mobile .burger-icon span::before,
  .sa-theme .header-mobile .burger-icon span::after {
    background-color: #1e293b !important;
  }

  .sa-theme .sa-aside-footer {
    padding: 8px 16px 20px;
    text-align: center;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.45);
  }

  /* —— Super Admin mobile layout —— */
  @media (max-width: 991.98px) {
    body.mobile-toggle-active {
      overflow: hidden !important;
    }

    .sa-theme #kt_wrapper.wrapper {
      padding-top: 56px !important;
      padding-left: 0 !important;
    }

    .sa-theme #kt_header.header,
    .sa-theme .header.sa-header {
      /* Keep in DOM so QuickUser panel can open from mobile header */
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      overflow: visible !important;
      visibility: hidden !important;
      pointer-events: none !important;
      z-index: 10040 !important;
      border: none !important;
      box-shadow: none !important;
      background: transparent !important;
    }

    .sa-theme #kt_header .sa-header-left,
    .sa-theme #kt_header .sa-header-search,
    .sa-theme #kt_header .sa-user-chip {
      display: none !important;
    }

    .sa-theme #kt_header .topbar-item,
    .sa-theme #kt_header #kt_quick_user {
      display: block !important;
      visibility: visible !important;
      pointer-events: auto !important;
    }

    .sa-theme #kt_header .quick-user-toggle {
      display: none !important;
    }

    .sa-theme #kt_header #kt_quick_user.offcanvas-on {
      display: block !important;
      position: fixed !important;
      top: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      left: auto !important;
      width: min(375px, 100vw) !important;
      height: 100dvh !important;
      z-index: 10080 !important;
      transform: translateX(0) !important;
      visibility: visible !important;
      pointer-events: auto !important;
      opacity: 1 !important;
    }

    .sa-theme .header-mobile,
    .sa-theme .sa-header-mobile {
      display: flex !important;
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      width: 100% !important;
    }

    .sa-theme #kt_content,
    .sa-theme .content {
      padding-top: 0 !important;
      padding-bottom: 10px !important;
    }

    .sa-theme .layout-page-bottom-pad,
    .sa-theme .container-fluid.layout-page-bottom-pad {
      padding-left: 12px !important;
      padding-right: 12px !important;
      padding-bottom: 1.25rem !important;
    }

    .sa-theme .aside.aside-left {
      position: fixed !important;
      top: 0 !important;
      left: -100% !important;
      height: 100vh !important;
      width: 18.5rem !important;
      max-width: 88vw !important;
      z-index: 10050 !important;
      transform: none !important;
      transition: left 0.25s ease !important;
      box-shadow: 0 12px 30px rgba(22, 18, 74, 0.18) !important;
      border-radius: 0 !important;
    }

    .sa-theme .aside.aside-left.offcanvas-on,
    .sa-theme .aside.aside-left.aside-on {
      left: 0 !important;
      transform: none !important;
    }

    .sa-theme .aside-offcanvas-overlay,
    .sa-theme .aside-overlay {
      position: fixed !important;
      inset: 0 !important;
      background: rgba(15, 23, 42, 0.45) !important;
      z-index: 10040 !important;
    }

    /* Shared SA page mobile polish */
    .sa-theme .sa-biz-head,
    .sa-theme .sa-agents-head,
    .sa-theme .sa-billing-head,
    .sa-theme .sa-overview-head {
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 12px !important;
    }

    .sa-theme .sa-biz-head h1,
    .sa-theme .sa-agents-head h1,
    .sa-theme .sa-billing-head h1,
    .sa-theme .sa-overview-head h1 {
      font-size: 22px !important;
    }

    .sa-theme .sa-btn-primary,
    .sa-theme .sa-refresh-btn {
      width: 100% !important;
      justify-content: center !important;
    }

    .sa-theme .sa-table-wrap {
      overflow-x: auto !important;
      -webkit-overflow-scrolling: touch !important;
      margin: 0 -4px !important;
      padding: 0 4px !important;
    }

    .sa-theme .sa-table {
      min-width: 720px !important;
    }

    .sa-theme .sa-agents-page .sa-table {
      min-width: 420px !important;
    }

    .sa-theme .sa-billing-tabs {
      flex-wrap: nowrap !important;
      overflow-x: auto !important;
      -webkit-overflow-scrolling: touch !important;
    }

    .sa-theme .sa-tab {
      flex: 0 0 auto !important;
      white-space: nowrap !important;
    }
  }

  @media (max-width: 576px) {
    .sa-theme .sa-m-title {
      font-size: 15px !important;
    }

    .sa-theme .layout-page-bottom-pad,
    .sa-theme .container-fluid.layout-page-bottom-pad {
      padding-left: 10px !important;
      padding-right: 10px !important;
    }

    .sa-theme .sa-biz-card,
    .sa-theme .sa-agents-card,
    .sa-theme .sa-billing-card {
      border-radius: 12px !important;
    }
  }

  /* —— Business layout (match SA primary + top bar) —— */
  .biz-theme {
    --primary: #241B5A;
    --gmf-brand-50: #eef0ff;
    --gmf-brand-100: #e0e7ff;
    --gmf-brand-600: #241b5a;
    --gmf-brand-900: #16124a;
    --gmf-slate-400: #94a3b8;
    --gmf-slate-600: #475569;
    font-family: "Inter", ui-sans-serif, system-ui, sans-serif;
    color: #475569;
  }

  .biz-theme #kt_wrapper.wrapper {
    padding-top: 65px !important;
    background: #faf8f6 !important;
    background-image: none !important;
  }

  .biz-theme #kt_content,
  .biz-theme .content {
    padding-top: 12px !important;
    padding-bottom: 8px !important;
    background: #faf8f6 !important;
    background-image: none !important;
    color: #475569 !important;
    font-family: "Inter", ui-sans-serif, system-ui, sans-serif;
  }

  .biz-theme .container-fluid.layout-page-bottom-pad,
  .biz-theme .layout-page-bottom-pad {
    padding-top: 12px !important;
    margin-top: 0 !important;
  }

  /* Ensure fixed header does not leave a double gap (subheader was previously reserved) */
  body.header-fixed .biz-theme #kt_wrapper.wrapper,
  body.header-fixed.subheader-fixed .biz-theme #kt_wrapper.wrapper,
  body.header-fixed.subheader-fixed.subheader-enabled .biz-theme #kt_wrapper.wrapper {
    padding-top: 65px !important;
  }

  .biz-theme #kt_header.header.biz-header {
    position: fixed !important;
    top: 0 !important;
    left: 275px !important;
    right: 0 !important;
    width: auto !important;
    height: 65px !important;
    min-height: 65px !important;
    z-index: 104 !important;
  }

  .biz-theme .subheader {
    display: none !important;
    height: 0 !important;
    min-height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .biz-theme #kt_header.header,
  .biz-theme .header.biz-header,
  .sa-theme #kt_header.header,
  .sa-theme .header.sa-header {
    background: #ffffff !important;
    box-shadow: none !important;
    border-bottom: 1px solid #e8e8ee !important;
    overflow: visible !important;
  }

  .biz-theme .biz-header-title,
  .sa-theme .sa-header-title {
    color: #16124a !important;
    font-family: "Inter", ui-sans-serif, system-ui, sans-serif !important;
    font-weight: 600 !important;
  }

  .biz-theme #kt_footer.footer {
    background: #ffffff !important;
    border-top: 1px solid #eef1f6 !important;
  }

  .biz-theme #kt_footer .text-dark,
  .biz-theme #kt_footer .text-dark-75,
  .biz-theme #kt_footer a {
    color: #475569 !important;
  }

  .biz-theme #kt_footer .text-muted {
    color: #94a3b8 !important;
  }

  .biz-theme .bg-primary,
  .biz-theme .btn-primary,
  .biz-theme .btn.btn-primary,
  .biz-theme .v-btn.bg-primary {
    background: #241B5A !important;
    background-color: #241B5A !important;
    border-color: #241B5A !important;
    color: #ffffff !important;
    box-shadow: 0 4px 6px rgba(36, 27, 90, 0.25) !important;
  }

  .biz-theme .bg-primary:hover,
  .biz-theme .btn-primary:hover,
  .biz-theme .v-btn.bg-primary:hover {
    background: #16124a !important;
    background-color: #16124a !important;
    border-color: #16124a !important;
    color: #ffffff !important;
  }

  .biz-theme .text-primary {
    color: #241B5A !important;
  }

  @media (min-width: 992px) {
    body.aside-minimize:not(.aside-minimize-hover) .biz-theme #kt_header.header.biz-header {
      left: 70px !important;
    }
  }

  /* —— Business mobile layout —— */
  @media (max-width: 991.98px) {
    .biz-theme #kt_wrapper.wrapper {
      padding-top: 56px !important;
      padding-left: 0 !important;
    }

    .biz-theme #kt_header.header,
    .biz-theme .header.biz-header {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      overflow: visible !important;
      visibility: hidden !important;
      pointer-events: none !important;
      z-index: 10040 !important;
      border: none !important;
      box-shadow: none !important;
      background: transparent !important;
    }

    .biz-theme #kt_header .biz-header-left,
    .biz-theme #kt_header .biz-header-title,
    .biz-theme #kt_header .topbar > *:not(.topbar-item) {
      display: none !important;
    }

    .biz-theme #kt_header .topbar,
    .biz-theme #kt_header .topbar-item {
      display: block !important;
      visibility: visible !important;
      pointer-events: auto !important;
      width: 0 !important;
      height: 0 !important;
      overflow: visible !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .biz-theme #kt_header .quick-user-toggle {
      display: none !important;
    }

    .biz-theme #kt_header #kt_quick_user {
      visibility: hidden !important;
      pointer-events: none !important;
    }

    .biz-theme #kt_header #kt_quick_user.offcanvas-on {
      display: block !important;
      position: fixed !important;
      top: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      left: auto !important;
      width: min(375px, 100vw) !important;
      height: 100dvh !important;
      z-index: 10080 !important;
      transform: translateX(0) !important;
      visibility: visible !important;
      pointer-events: auto !important;
      opacity: 1 !important;
    }

    .biz-theme .header-mobile,
    .biz-theme .biz-header-mobile {
      display: flex !important;
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      width: 100% !important;
    }

    .biz-theme #kt_content,
    .biz-theme .content {
      padding-top: 0 !important;
    }

    .biz-theme .aside.aside-left {
      position: fixed !important;
      top: 0 !important;
      left: -100% !important;
      height: 100vh !important;
      z-index: 10050 !important;
      transform: none !important;
      pointer-events: auto !important;
    }

    .biz-theme .aside.aside-left.offcanvas-on,
    .biz-theme .aside.aside-left.aside-on {
      left: 0 !important;
      transform: none !important;
    }

    .biz-theme .aside-offcanvas-overlay,
    .biz-theme .aside-overlay {
      position: fixed !important;
      inset: 0 !important;
      background: rgba(15, 23, 42, 0.4) !important;
      z-index: 10040 !important;
    }

    .biz-theme .layout-page-bottom-pad,
    .biz-theme .container-fluid.layout-page-bottom-pad,
    .biz-theme .container.layout-page-bottom-pad {
      padding-left: 12px !important;
      padding-right: 12px !important;
      padding-bottom: 1.25rem !important;
      max-width: 100% !important;
    }

    .biz-theme .table-responsive {
      margin-left: -4px;
      margin-right: -4px;
    }

    .biz-theme .v-data-table {
      width: 100% !important;
    }

    .biz-theme .card-custom {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  @media (max-width: 991.98px) {
    body.quick-user-open .sa-theme #kt_header.header,
    body.quick-user-open .biz-theme #kt_header.header,
    body.quick-user-open #kt_header.header {
      z-index: 10080 !important;
      visibility: visible !important;
      pointer-events: none !important;
      overflow: visible !important;
    }

    body.quick-user-open #kt_quick_user.offcanvas-on {
      pointer-events: auto !important;
    }

    .quick-user-overlay {
      position: fixed !important;
      inset: 0 !important;
      background: rgba(15, 23, 42, 0.45) !important;
      z-index: 10070 !important;
    }
  }
</style>

<style src="@/assets/css/tailwind.css"></style>
